<template>
    <div id="print" v-if="objAudioAndLyric != null">
        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>本课词汇</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>
        <div class="bg_content">
            <img class="bg_img" v-lazy="lyricImg"/>
        </div>
        <div class="bg_color"></div>
        <div class="lyric_content">
            <div class="back_nav" @click="goToBack()"><img src="../../assets/back_nav.png"/></div>
            <img class="lyric_img" v-lazy="lyricImg"/>
            <div class="lyric" v-html="objAudioAndLyric.lyric"></div>
            <div class="lesson_audio">
                <div class="play" @click="changeStart">
                    <audio v-bind:src="$qiNiuDomainBase + objAudioAndLyric.audio"  id="musicMp3" controls=""></audio>
                    <img v-if="!isPlay" src="@/assets/player_play_w.png" height="40" width="40"/>
                    <img v-else src="@/assets/player_pause_w.png" height="40" width="40"/>
                </div>
                <div class="info">
                    <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                    <div class="mp3_progress">
                        <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                    </div>
                    <div class="time_end">{{objAudioAndLyric.audioDurationDisplayString}}</div>
                    <div class="clear"></div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Utils from "@/pages/Program/util2";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        name: "pchoicequestion",
        data() {
            return {
                showTransition: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                lessonId: 0,
                objAudioAndLyric:{},
                lyricImg:"",
                backgroundDiv:{
                    backgroundImage:'',
                    backgroundRepeat:'no-repeat',
                    backgroundSize:'100% auto',
                    "background-position": "center 0"},
                currentTime:0,
                isPlay: false,
                mTimer:null,
                progress: 0,
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            gameQuitClick() {
                this.$router.go(-2);
            },
            nextPageClick:function () {
                this.$router.replace({name: 'PLessonWord', query: {lessonId: this.lessonId}});
            },
            touchmove(e) {
                e.preventDefault();
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    musicMp3.pause()
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration;
                    let perNumber = (numbers * 100).toFixed(2);
                    if (perNumber >= 100) {
                        that.isPlay = false;
                        that.progress = 0;
                        that.currentTime = 0;
                        clearInterval(that.mTimer);
                        that.mTimer = null;

                        that.showFinishTransition();
                    } else {
                        that.progress = perNumber;
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            callChangeProgress:function () {
                let that = this;
                document.getElementById('musicMp3').pause();
                that.changeProgress()
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;

                setTimeout(() => {
                    const greatAudio = document.getElementById('great_audio');
                    greatAudio.play();
                }, 200);

                Utils.$emit('setStarCount','8');
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "/englishProgram/getLessonAudioAndLyric/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.objAudioAndLyric = response.data;
                that.lyricImg = that.$qiNiuDomainBase + that.objAudioAndLyric.picture + "?imageView2/1/w/300/h/300";
                that.lessonId = vLessonId;

                that.backgroundDiv.backgroundImage = 'url(' + that.lyricImg + ')';
                that.hideStatusAndStopAudio();

                setTimeout(() => {
                    transformView();

                    setTimeout(function () {
                        that.changeStart();
                    }, 200);
                }, 100);

            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .lyric_img {
        position: absolute;
        left: 60px;
        margin-top: calc((100vmin - 180px)/2.0);
        width: 120px;
        height: 120px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .back_nav {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }
    .lyric_content {

    }

    ::-webkit-scrollbar {
        display: none;
    }

    .lyric {
        position: absolute;
        width: calc(100vmax - 60px - 120px - 200px);
        height: calc(100vmin - 20px - 60px);
        overflow: scroll;
        top: 20px;
        right: 100px;
        padding-bottom: 20px;
        color: white;
        text-align: center;
        line-height: 28px;
        font-size: 18px;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
        -webkit-overflow-scrolling: touch;
    }
    .lesson_audio {
        position: absolute;
        width: 100vmax;
        height: 60px;
        background-color: #00000098;
        padding: 22px;
        bottom: 0;
    }
    .lesson_audio .info {
        margin-left: 105px;
        display: flex;
        align-items: center;
    }
    .lesson_audio .play {
        position: absolute;
        width: 40px;
        height: 40px;
        left: 80px;
        top: 50%;
        -webkit-transform:translateY(-50%);
    }
    .lesson_audio .info .mp3_progress {
        display: inline-block;
        width: calc(100% - 160px);
        height: 4px;
        background-color: #808285;
        vertical-align: middle;
    }
    .lesson_audio .info .time_start {
        display: inline-block;
        font-size: 13px;
        color: white;
        margin-right:8px;
    }
    .lesson_audio .info .time_end {
        display: inline-block;
        font-size: 13px;
        color: white;
        margin-Left:8px;
        vertical-align: middle;
    }
    .lesson_audio .info .now_progress {
        position: relative;
    @extend %transition;
        height: 4px;
        background-color: white;
    }
    audio{
        display: none;
    }
    .bg_content {
        position: absolute;
        width: 100vmax;
        height: 100vmin;
        -webkit-filter: blur(40px); /* Chrome, Opera */
        -moz-filter: blur(40px);
        -ms-filter: blur(40px);
        filter: blur(40px);
    }
    .bg_img {
        width: 100%;
        height: 100%;
    }
    .bg_color {
        position: absolute;
        width: 100vmax;
        height: 100vmin;
        background-color: #00000090;
    }

   .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes zoom1 {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
</style>

